export type ResourceContextConfig = { frustumCulling: boolean };

/**
 * Create resources context config.
 */
export const create = (() => {
  const ConfigDef: ResourceContextConfig = { frustumCulling: true };

  return (config?: Partial<ResourceContextConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
